import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerName">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Title-Files"
                                    defaultMessage="Dokumente"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href='/langnau-initiative-baurechtliche-grundordnung-unterschriftenflyer-seiten-1-bis-4-definitivum.pdf/@@download/file'>
                                <FormattedMessage
                                    id="Footer-Unterschriftenbogen"
                                    defaultMessage="Unterschriftenbogen"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href='/langnau-initiative-baurechtliche-grundordnung-unterschriftenflyer-seiten-1-bis-4-definitivum.pdf/@@download/file'>
                                <FormattedMessage
                                    id="Footer-Flyer"
                                    defaultMessage="Flyer"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href='/langnau-initiative-warum-diese-initiative-definitivum.pdf/@@download/file'>
                                <FormattedMessage
                                    id='Footer-Warum'
                                    defaultMessage="Warum diese Initiative?"
                                />
                            </a>
                        </div>
                    </List>
                </div>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerName">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Title"
                                    defaultMessage="Initiativkomitee"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Name"
                                    defaultMessage="Armin Brunner"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Adress"
                                    defaultMessage="Bernstrasse 17"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id='Footer-Plz-Ort'
                                    defaultMessage="3550, Langnau i.E."
                                />
                            </p>
                        </div>
                    </List>
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <i className="ri-mail-line"></i>
                            <a className="item" href="mailto:info@initiative-langnau.ch">
                                <FormattedMessage
                                    id='Footer-Email'
                                    defaultMessage="info@initiative-langnau.ch"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-phone-line"></i>
                            <a className="item" href="tel:+41793003866">
                                <FormattedMessage
                                    id='Footer-Telefon'
                                    defaultMessage="079 300 38 66"
                                />
                            </a>
                        </div>
                        <div>
                            <a className="item socialIcon" href="https://www.facebook.com/profile.php?id=61583573390465" target="_blank">
                                <i className="ri-facebook-circle-fill"></i>
                            </a>
                            <a className="item socialIcon" href="https://www.instagram.com/initiative_langnau/" target="_blank">
                                <i className="ri-instagram-line"></i>
                            </a>
                        </div>
                    </List>
                </div>
            </div>
            <hr />
            <div className='footerBottom'>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="initiative-langnau.ch"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);